export default __webpack_public_path__ + "static/media/Slide1.408efd12.jpg";